var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrador Lyris"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Dashboard")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }